import { ArrowRight, Check, Users } from 'lucide-react'
import { Link } from 'react-router-dom'

export function Pricing(){return <>
  <section className="public-page-hero public-container">
    <span className="public-kicker">Pricing</span>
    <h1>Simple pricing for the people Mail Percent measures.</h1>
    <p>Pay for measured users, not for managers who only need to view the workspace. Start with a 14-day free trial and scale the same plan as your team grows.</p>
  </section>

  <section className="public-section public-container">
    <div className="pricing-public-card pricing-live-card">
      <div>
        <span className="public-kicker">Mail Percent</span>
        <h2>One plan. Your whole email operation.</h2>
        <p>Measure customer-facing email work across Gmail and Outlook without building a complicated plan around features, mailboxes or manager seats.</p>

        <ul>
          <li><Check/>Gmail and Microsoft Outlook support</li>
          <li><Check/>Response-time, queue and workload measurements</li>
          <li><Check/>Team workload and queue context</li>
          <li><Check/>SLA Performance by organisation and team</li>
          <li><Check/>Employee, team and manager reporting</li>
          <li><Check/>Personal and shared mailbox workflows</li>
        </ul>
      </div>

      <div className="pricing-action pricing-live-action">
        <small>Per measured user</small>
        <div className="pricing-price"><strong>R245</strong><span>/ month</span></div>
        <p>Only people whose email work is actively measured count as paid users.</p>
        <div className="pricing-included-note"><Users size={17}/><span><b>Managers and admins are free</b> when they only view reports and manage the workspace.</span></div>
        <Link to="/signup" className="button primary public-cta">Start 14-day free trial <ArrowRight size={16}/></Link>
        <span className="pricing-trial-note">No separate charge for a shared mailbox used by measured team members.</span>
      </div>
    </div>
  </section>

  <section className="public-section public-soft-section">
    <div className="public-container">
      <div className="public-section-heading">
        <span className="public-kicker">Easy to calculate</span>
        <h2>Your monthly price follows the size of the measured team.</h2>
        <p>Viewer-only managers do not add seats. Shared inboxes do not add another licence on top of the people doing the measured work.</p>
      </div>

      <div className="public-proof-grid pricing-examples">
        <div><strong>5</strong><span>measured users</span><small>R1,225 / month</small></div>
        <div><strong>10</strong><span>measured users</span><small>R2,450 / month</small></div>
        <div><strong>20</strong><span>measured users</span><small>R4,900 / month</small></div>
        <div><strong>50+</strong><span>measured users</span><small>Volume pricing</small></div>
      </div>
    </div>
  </section>

  <section className="public-section public-container public-final-cta">
    <div>
      <span className="public-kicker">Larger organisation?</span>
      <h2>Need Mail Percent across 50 or more measured users?</h2>
      <p>Talk to us about volume pricing, rollout planning and the mailbox setup your teams already use.</p>
    </div>
    <div>
      <Link to="/contact" className="button primary public-cta">Contact Mail Percent <ArrowRight size={16}/></Link>
      <Link to="/how-it-works" className="button ghost public-cta">See how it works</Link>
    </div>
  </section>
</>}
